export default __webpack_public_path__ + "static/media/lanternRight.min.c06479c6.png";